<template>
  <b-modal :title="title"
    v-model="showModal"
    :ok-title="okText"
    :cancel-title="cancelText"
    @ok="submit"
    @cancel="cancel"
    @hide="cancel"
  >
    <slot>
      <p>{{message}}</p>
    </slot>
  </b-modal>
</template>
<script>

export default {
  props: {
    title: { type: String, default: '' },
    okText: { type: String, default: 'Ok' },
    cancelText: { type: String, default: 'Cancel' },
    message: { type: String, default: "Are you sure?" }
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    show(){
      this.showModal = true;
    },
    hide(){
      this.showModal = false;
    },
    submit() {
      this.$emit('submit');
    },
    cancel() {
      this.$emit('cancel');
    },
  }
}

</script>